import React from "react";
import { Box, Typography, useTheme, Skeleton } from "@mui/material";
import { FaSquareFull } from "react-icons/fa6";
import { useGetPlanVsActualQuery } from "store/slices/apis/scheduleDashboarSlice";
import { useParams } from "react-router-dom";

const ProjectDuration = () => {
  const theme = useTheme();
  const { projectId } = useParams();
  const { data, isLoading } = useGetPlanVsActualQuery({ projectId });

  const actualDays = data?.daysElapsed || 0;
  const remainingDays = data?.daysRemaining || 0;
  const totalDays = data?.projectDurationDays || 1;

  const actualWidth = `${(actualDays / totalDays) * 100}%`;
  const remainingWidth = `${(remainingDays / totalDays) * 100}%`;

  return (
    <Box sx={{ p: 2, pb: 0, pr: 0, border: '1px solid #2525252E', borderRadius: '7px', minHeight: '230px', background: "#FFFFFF", width: "100%" }}>
      <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `${theme?.customSettings?.themeColor}`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
        Project Duration In Days
      </Typography>
      <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '14px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
        Track elapsed and remaining time to evaluate schedule status and forecast completion
      </Typography>

      <Box sx={{ display: "flex", gap: 1, mt: 2, p: 1 }}>
        {isLoading ? (
          <>
            <Skeleton variant="rectangular" width="50%" height={70} />
            <Skeleton variant="rectangular" width="50%" height={70} />
          </>
        ) : (
          <>
            <Box
              sx={{
                width: actualWidth === "0%" ? "auto" : actualWidth,
                backgroundColor: "#415385",
                color: "white",
                p: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: '70px'
              }}
            >
              <Typography variant="subtitle1">{actualDays}</Typography>
            </Box>

            <Box
              sx={{
                width: remainingWidth === "0%" ? "auto" : remainingWidth,
                backgroundColor: "gray",
                color: "white",
                p: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: '70px'
              }}
            >
              <Typography variant="subtitle1">{remainingDays}</Typography>
            </Box>
          </>
        )}
      </Box>

      {/* Legend */}
      <Box sx={{ display: "flex", gap: 4, mt: 2, mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FaSquareFull style={{ color: "#415385", height: 10, width: 10 }} />
          <Typography variant="body2">Days Elapsed</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FaSquareFull style={{ color: "gray", height: 10, width: 10 }} />
          <Typography variant="body2">Remaining Days</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectDuration;
